<template>
  <div>
    <b-alert
      v-model="showDismissibleAlert"
      variant="danger"
      dismissible
    >There was an error while trying to connect canvas.</b-alert>
    <article class="container">
      <p
        class="font18"
      >Create a Canvas account. You will use this account to log in and out of Canvas, and access and manage your courses.</p>
      <b-form action @submit.prevent="handleSubmit">
        <b-form-group id="lblfirstName" label="First name" label-for="txtfirstName">
          <b-form-input
            id="txtfirstName"
            v-model="first_name"
            v-validate="'required'"
            type="text"
            disabled
            :class="{ 'is-invalid': errors.has('first_name') }"
            name="first_name"
            data-vv-as="First Name"
            placeholder="Enter your first name"
          />
          <span class="invalid-feedback">
            {{
            errors.first('first_name')
            }}
          </span>
        </b-form-group>

        <b-form-group id="lblastName" label="Last name" label-for="txtlastName">
          <b-form-input
            id="txtlastName"
            v-model="last_name"
            v-validate="'required'"
            data-vv-as="Last Name"
            type="text"
            disabled
            :class="{ 'is-invalid': errors.has('last_name') }"
            name="last_name"
            placeholder="Enter your last name"
          />
          <span class="invalid-feedback">
            {{
            errors.first('last_name')
            }}
          </span>
        </b-form-group>

        <b-form-group id="lblemail" label="Email address:" label-for="txtemail">
          <b-form-input
            id="txtemail"
            v-model="email"
            v-validate="'required|email'"
            type="email"
            :class="{ 'is-invalid': errors.has('email') }"
            name="email"
            disabled
            placeholder="Enter your email address"
          />
          <span class="invalid-feedback">{{ errors.first('email') }}</span>
        </b-form-group>
        <b-form-group id="lblrepassword" label="Password" label-for="txtrepassword">
          <b-form-input
            id="password"
            ref="password"
            v-model="password"
            v-validate="'required|min:8'"
            :class="{ 'is-invalid': errors.has('password') }"
            type="password"
            name="password"
            placeholder="Enter your password"
          />
          <span class="invalid-feedback">{{ errors.first('password') }}</span>
        </b-form-group>

        <b-form-group id="lblpassword" label="Re-enter password" label-for="txtrepassword">
          <b-form-input
            v-model="repassword"
            v-validate="'required|confirmed:password'"
            name="password_confirmation"
            type="password"
            placeholder="Re-enter your password"
            data-vv-as="Re-enter password"
            :class="{ 'is-invalid': errors.has('password_confirmation') }"
          />
          <span class="invalid-feedback">
            {{
            errors.first('password_confirmation')
            }}
          </span>
        </b-form-group>

        <button
          style="min-width:200px"
          type="submit"
          class="my-2 btn btn-secondary btn-lg float-lg-right d-md-block"
        >
          <template v-if="!tryingConnectCanvas">Create account</template>
          <b-spinner v-else label="Loading..."></b-spinner>
        </button>
      </b-form>
    </article>
    <!-- End of modal -->
  </div>
</template>

<script>
const _ = require("lodash");
import { mapGetters } from "vuex";
import { NEW_CANVAS_USER } from "../store/actions.type";
export default {
  data() {
    return {
      email: "",
      password: "",
      repassword: "",
      showDetails: false,
      apiCall: null,
      first_name: "",
      last_name: "",
      tryingConnectCanvas: false,
      showDismissibleAlert: false,
      courseDetails: {},
      currentStatus: "Please wait we are trying to create your account"
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  methods: {
    handleSubmit(e) {
      let self = this;
      this.$validator.validate().then(async valid => {
        if (valid) {
          this.tryingConnectCanvas = true;
          this.apiCall = null;
          this.$store
            .dispatch(NEW_CANVAS_USER, {
              first_name: this.first_name,
              last_name: this.last_name,
              email_address: this.email,
              password: this.password,
              course_id: this.$store.state.selectedCourse
            })
            .then(response => {
              this.tealuimUpdate((callback) => {
                this.createAccount();
                window.location = response.destination_url;
                let modalClass = document.getElementsByClassName(
                  "modal-header"
                )[0];
                let close = modalClass.getElementsByClassName("close")[0];
                close.click();
              });
            })
            .catch(error => {
              this.tryingConnectCanvas = false;
              this.showDismissibleAlert = true;
              this.apiCall = error;
            });
        }
      });
    },
    createAccount(){
      utag.link({
        event:"link",
        action:"click",
        type:"internal link",
        section:"create an account",
        text:"create account",
        first_name:this.first_name,
        last_name:this.last_name,
        email_address:this.email_address,
        tealium_event:"create_account_event"
        })
    },
    tealuimUpdate(callback) {
      utag.link({
        course_title: this.$store.state.selectedCourseTitle,
        customer_email: this.email,
        customer_full_name: this.first_name,
        listing_fee: "0.0",
        enrollment_fee: "0.0",
        order_total: "0.0",
        listing_id: this.$store.state.listingId,
        listing_url: window.location.href,
        timestamp: new Date() + "",
        tealium_event: "enrollment_finished_event"
      });
      callback()
    }
  },
  mounted() {
    this.email = this.currentUser.user.email_address;
    this.first_name = this.currentUser.user.first_name;
    this.last_name = this.currentUser.user.last_name;
  }
};
</script>


<style>
#create-account {
  padding: 0 !important;
}
</style>
